<template>
    <v-input-text
        @keyup.enter.native="handleKeyEnter"
        @keyup.down.native="handleKeyDown"
        @keyup.up.native="handleKeyUp"
        @focus="handleFocus"
        @blur="handleBlur"
        @input="handleInput"
        @assistant-before-leave="isLeaving = true"
        @assistant-after-leave="isLeaving = false"
        autocomplete="off"
        :theme="theme"
        :class="classes"
        :value="inputValue"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="select || readonly"
        :caption="caption"
        :error="error"
        :name="name"
        :type="type"
        :maxlength="maxlength"
    >
        <template slot="assistant-action" scope="props">
            <v-icon-button :class="theme.eventsNone">
                keyboard_arrow_down
            </v-icon-button>
        </template>

        <template slot="assistant" scope="props">
            <div v-if="isOpen" v-shadow="2" :class="{[theme.select]: select}">
                <div :class="theme.autosuggestsContainer">
                    <v-dropdown-raw
                        @mouseleave.native="handleMouseleave"
                        @mouseenter.native="handleMouseenter"
                        :value="suggestions[selectedIndex]"
                        :items="suggestions"
                        :theme="dropdownTheme"
                        @select="handleSelect($event); clearValueCache();"
                    >
                        <template slot="item" scope="props">
                            <slot name="item" :item="props.item">
                                <span>{{ getItemValue(props.item) }}</span>
                            </slot>
                        </template>
                    </v-dropdown-raw>
                </div>
            </div>
        </template>
    </v-input-text>
</template>

<script>
    import { vIconButton } from '../Button';
    import { vInputText } from '../InputText';
    import { vDropdownRaw } from '../Dropdown';
    import { Shadow } from '../../directives';
    import theme from './autosuggest.scss';

    function filterSuggestionDefault(itemValue, inputValue = '') {
        const valueFormated = inputValue.toString().trim().toLowerCase();
        const itemFormated = itemValue.toString().trim().toLowerCase();

        return itemFormated
            ? itemFormated.slice(0, valueFormated.length) === valueFormated
            : true
    }

    export default {
        name: 'autosuggest',
        components: {
            vInputText,
            vDropdownRaw,
            vIconButton,
        },
        directives: {
            Shadow,
        },
        props: {
            items: {
                type: Array,
                default() {
                    return [];
                }
            },
            getItemValue: {
                type: Function,
                default: (item) => typeof item === 'object' ? item.name : item,
            },
            getItemId: {
                type: Function,
                default: (item) => typeof item === 'object' ? item.id : item,
            },
            getItemCaption: {
                type: Function,
                default: null
            },
            filterSuggestion: {
                type: Function,
                default: filterSuggestionDefault,
            },
            value: {
                type: [String, Number, Object],
                default: ''
            },
            theme: {
                type: Object,
                default() {
                    return theme;
                },
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            dropdownTheme: Object,
            label: String,
            placeholder: String,
            disabled: Boolean,
            select: Boolean,
            caption: String,
            error: String,
            name: String,
            type: String,
            maxlength: [String, Number]
        },
        methods: {
            handleFocus() {
                this.inFocus = true;
            },
            handleBlur() {
                this.inFocus = false;
                this.selectedIndex = -1;
            },
            handleSelect(item) {
                this.isEnter = false;
                this.$emit('input', item);
            },
            handleInput(value) {
                if (!value) {
                    this.$emit('input', '');
                    this.selectedIndex = -1;
                } else {
                    this.$emit('input', value);
                }

                this.clearValueCache();
            },
            handleMouseenter() {
                if (!this.isLeaving) {
                    this.isEnter = true;
                }
            },
            handleMouseleave() {
                this.isEnter = false;
            },
            handleKeyDown() {
                if (!this.inFocus) {
                    return;
                }

                const nextSelected = this.selectedIndex + 1;

                this.selectedIndex = this.suggestions.length > nextSelected
                    ? nextSelected
                    : 0;

                this.setValueCache(this.suggestions[this.selectedIndex]);
                this.isEnter = false;
            },
            handleKeyUp() {
                if (!this.inFocus) {
                    return;
                }

                const nextSelected = this.selectedIndex - 1;

                this.selectedIndex = nextSelected < 0
                    ? this.suggestions.length - 1
                    : nextSelected;

                this.setValueCache(this.suggestions[this.selectedIndex]);
                this.isEnter = false;
            },
            handleKeyEnter() {
                if (this.selectedIndex !== -1) {
                    this.handleSelect(this.suggestions[this.selectedIndex]);
                    this.clearValueCache();
                }

                this.isEnter = false;

//                this.handleBlur();
            },

            clearValueCache() {
                this.cacheValue = undefined;
            },

            setValueCache(value) {
                this.cacheValue = value;
            }
        },
        computed: {
            isOpen() {
                return (!this.readonly && !this.disabled) && (this.inFocus || this.isEnter);
            },

            classes() {
                return {
                    [this.theme.isSelect]: this.select,
                }
            },

            inputValue() {
                return this.cacheValue === undefined
                    ? this.getItemValue(this.value)
                    : this.getItemValue(this.cacheValue);
            },

            suggestions() {
                if (this.select) {
                    return this.items;
                }

                const value = this.cacheValue === undefined
                    ? this.inputValue
                    : this.value;

                if (this.getItemCaption) {
                    const r = this.items.map(item => this.getItemCaption(item));
                    return r;
                }

                return this.items.filter((item) =>
                    this.filterSuggestion(
                        this.getItemValue(item),
                        value
                    ));
            }
        },
        watch: {
            isOpen(newIsOpen) {
                if (!newIsOpen) {
                    this.$emit('blur');
                }
            },

            // value(newValue) {
            //     console.log('newValue', newValue)
            // }
        },
        data() {
            return {
                cacheValue: undefined,
                inFocus: false,
                isEnter: false,
                selectedIndex: -1,
                isLeaving: false,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Autosuggest.vue?48c320cc